export const ECOSYSTEM_LINKS = {
  intelligence: {
    home: "https://integratednycai.com/",
  },
  optimize: {
    home: "https://iwoptimizeme.com/",
    programs: "https://iwoptimizeme.com/#programs",
    getStarted: "https://iwoptimizeme.com/get-started",
  },
  labs: {
    home: "https://homebloodkit.com/",
    shop: "https://homebloodkit.com/#shop",
  },
};